var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.showing ? 'display:grid; grid-template-columns: 1fr 1fr; grid-gap: 5px; margin-right:11px' : 'display:grid; grid-template-columns: 1fr; margin-right:11px')},[_c('input',{staticClass:"form-control",attrs:{"type":"search","placeholder":_vm.labelSearch},on:{"input":_vm.emitSearch}}),_vm._v(" "),_vm._t("button")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }